import React from "react";
import DueBillsGrid from "./Grid";
import WithDrawer from "./../../../Dispatch/Common/Drawer/WithDrawer";
import Footer from "../../components/Footer";
import CancelButton from "../../components/Buttons/CancelButton";
import { Button } from "@material-ui/core";
class DueBill extends React.Component {
  constructor(props) {
    super(props);
  }

  onGridReady = ({ api }) => {
    this.gridApi = api;
  };


  handleSubmit = () => {
    this.props.onSubmit(this.gridApi.getSelectedRows().map((pro) => pro.proId));
  };

  render() {
    return (
      <>
        <DueBillsGrid
          rowData={this.props.data}
          glEventHub={this.props.glEventHub}
          serviceLevelList={this.props.serviceLevelList}
          onGridReady={this.onGridReady}
          selectedPros={this.props.selectedPros}
        />
        <Footer>
          <CancelButton onClick={this.props.onCancel} />
          <Button
            variant="contained"
            color="primary"
            onClick={this.handleSubmit}
          >
            Done
          </Button>
        </Footer>
      </>
    );
  }
}

export default WithDrawer(DueBill);
